var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7996 14.6452H30.625V14.5846H17.5V20.418H25.7417C24.5393 23.8137 21.3084 26.2513 17.5 26.2513C12.6678 26.2513 8.74996 22.3335 8.74996 17.5013C8.74996 12.6691 12.6678 8.7513 17.5 8.7513C19.7305 8.7513 21.7598 9.59276 23.3049 10.9672L27.4298 6.84234C24.8252 4.41495 21.3412 2.91797 17.5 2.91797C9.44631 2.91797 2.91663 9.44766 2.91663 17.5013C2.91663 25.5549 9.44631 32.0846 17.5 32.0846C25.5536 32.0846 32.0833 25.5549 32.0833 17.5013C32.0833 16.5235 31.9827 15.569 31.7996 14.6452Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59814 10.7135L9.3895 14.2273C10.686 11.0176 13.8257 8.7513 17.5 8.7513C19.7305 8.7513 21.7598 9.59276 23.3049 10.9672L27.4298 6.84234C24.8252 4.41495 21.3413 2.91797 17.5 2.91797C11.8986 2.91797 7.04085 6.08036 4.59814 10.7135Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 32.0843C21.2669 32.0843 24.6896 30.6428 27.2774 28.2985L22.7639 24.4791C21.2997 25.5882 19.4797 26.251 17.5 26.251C13.7069 26.251 10.4862 23.8323 9.27284 20.457L4.51721 24.1211C6.93075 28.8439 11.8322 32.0843 17.5 32.0843Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7997 14.6426H30.625V14.582H17.5V20.4154H25.7418C25.1643 22.0465 24.115 23.4531 22.7617 24.4776L22.7639 24.4761L27.2774 28.2955C26.958 28.5857 32.0833 24.7904 32.0833 17.4987C32.0833 16.5209 31.9827 15.5664 31.7997 14.6426Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e03b3b85964499bff8bf6f3d9c869bf1.svg";
export { ForwardRef as ReactComponent };